<div class="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center p-4 sm:p-6">
  <div class="max-w-md w-full animate-in fade-in slide-in-from-bottom-4 duration-500">
    <div class="flex items-center justify-center gap-3 mb-8">
      <div class="w-11 h-11 bg-navy rounded-xl flex items-center justify-center shadow-lg shadow-navy/20">
        <img ngSrc="logo.svg" height="24" width="24" alt="BAILIA" class="w-6 h-6 object-contain brightness-0 invert" />
      </div>
      <span class="text-xl font-display font-bold text-navy tracking-wide">BAILIA</span>
    </div>

    <div class="bg-white rounded-3xl shadow-xl shadow-navy/5 border border-gray-100 p-8 text-center">
      @if (status() === 'verifying') {
        <div class="py-10 animate-in fade-in" role="status" aria-live="polite">
          <div class="w-24 h-24 mx-auto rounded-full bg-gray-50 flex items-center justify-center mb-6">
            <ng-icon name="lucideLoader2" class="text-navy animate-spin" size="40"></ng-icon>
          </div>
          <h1 class="text-2xl font-display font-bold text-navy mb-2">Vérification en cours…</h1>
          <p class="text-gray-500">Nous validons votre lien de confirmation.</p>
        </div>
      } @else if (status() === 'error') {
        <div class="py-10 animate-in fade-in zoom-in-95 duration-500" role="status" aria-live="polite">
          <div class="w-24 h-24 mx-auto rounded-full bg-[#d4183d]/10 flex items-center justify-center mb-6">
            <ng-icon name="lucideXCircle" class="text-[#d4183d]" size="48"></ng-icon>
          </div>
          <h1 class="text-2xl font-display font-bold text-navy mb-2">Échec de la vérification</h1>
          <p class="text-gray-500 mb-8">{{ errorMessage() }}</p>
          <button
            z-button
            type="button"
            (click)="onBackToLogin()"
            class="w-full bg-navy hover:bg-navy/90 text-white h-12 rounded-full text-base font-semibold shadow-lg shadow-navy/20 transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            Retour à la connexion
          </button>
        </div>
      } @else {
        <div class="animate-in fade-in zoom-in-95 duration-500" role="status" aria-live="polite">
          <div class="relative w-24 h-24 mx-auto mb-6">
            <div class="absolute inset-0 rounded-full bg-emerald/20 animate-ping [animation-duration:2s] [animation-iteration-count:2]"></div>
            <div class="relative w-24 h-24 rounded-full bg-emerald flex items-center justify-center shadow-lg shadow-emerald/30 animate-in zoom-in duration-500">
              <ng-icon name="lucideCheck" class="text-white" size="48" strokeWidth="3"></ng-icon>
            </div>
          </div>

          <h1 class="text-2xl font-display font-bold text-navy mb-3">
            Compte vérifié{{ firstName() ? ', ' + firstName() : '' }} !
          </h1>
          <p class="text-gray-500 leading-relaxed">
            Votre adresse e-mail a bien été confirmée. Votre compte BAILIA est désormais actif et sécurisé.
          </p>

          <div class="mt-5 inline-flex items-center gap-2 bg-emerald/10 text-emerald rounded-full px-4 py-2 max-w-full">
            <ng-icon name="lucideMail" size="16" class="shrink-0"></ng-icon>
            <span class="text-sm font-semibold break-all">{{ email() || 'votre adresse e-mail' }}</span>
          </div>

          <ul class="mt-7 text-left space-y-3">
            @for (step of steps; track step.label) {
              <li
                class="flex items-center gap-3 rounded-2xl border px-4 py-3"
                [class]="step.done ? 'border-emerald/30 bg-emerald/5' : 'border-gray-100 bg-gray-50'"
              >
                <span
                  class="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
                  [class]="step.done ? 'bg-emerald text-white' : 'bg-white text-navy border border-gray-200'"
                >
                  @if (step.done) {
                    <ng-icon name="lucideCheck" size="16" strokeWidth="3"></ng-icon>
                  } @else {
                    <ng-icon [name]="step.icon" size="16"></ng-icon>
                  }
                </span>
                <span class="text-sm font-medium" [class]="step.done ? 'text-navy' : 'text-gray-500'">
                  {{ step.label }}
                </span>
              </li>
            }
          </ul>

          <button
            z-button
            type="button"
            (click)="onContinue()"
            class="w-full bg-emerald hover:bg-emerald/90 text-white h-12 rounded-full text-base font-semibold shadow-lg shadow-emerald/20 mt-7 transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            <div class="flex items-center justify-center w-full">
              Continuer <ng-icon name="lucideArrowRight" size="16" class="ml-2"></ng-icon>
            </div>
          </button>
        </div>
      }
    </div>
  </div>
</div>
